<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Form - Order Pasang Iklan (OPI)
                <div class="card-header-actions">
                <button  class="btn btn-primary mr-1" @click="save()" v-if="(saveEnabled==true)"><i class="fa fa-save" ></i> Save</button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
                </div>
            </div>
              <b-row class="expand-input">
                <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label>Nomor OPI</label></b-input-group-prepend>
                    <b-form-input v-model="model.orderno" readonly placeholder="AUTO NUMBERING" v-b-tooltip.hover title="Auto Numbering" ></b-form-input>
                    <b-input-group-prepend><span class="ml-2 mr-1 pt-2">Tanggal OPI</span></b-input-group-prepend>
                    <b-form-input v-model="model.orderdate" :state="$v.model.orderdate.$dirty ? !$v.model.orderdate.$error : null" type="date" class="mr-2"></b-form-input>
                  </b-input-group>
                  <b-row>
                      <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Sales Order</label></b-input-group-prepend>
                            <b-form-input placeholder="Pilih Sales Order" v-model="model.mediaorder" readonly></b-form-input>
                            <b-input-group-append>
                              <b-btn variant="primary" text="Button" @click="lkuSoShow=true" v-if="(!(model.orderid))">
                                  <i class="fa fa-search"></i>
                              </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                      </b-col>
                  </b-row>
                  <b-input-group >
                      <b-input-group-prepend><label>Pemasang</label></b-input-group-prepend>
                      <b-form-input placeholder="Masukkan Nama Pemasang" v-model="model.pemasang" ></b-form-input>
                      <b-input-group-prepend><span class="input-group-text">u.p Invoice</span></b-input-group-prepend>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Nama Biro Iklan</label></b-input-group-prepend>
                      <b-form-input placeholder="Pilih Biro Iklan" v-model="model.custinfo" :state="$v.model.customer_id.$dirty ? !$v.model.customer_id.$error : null" readonly></b-form-input>
                      <!-- <b-input-group-append>
                        <b-btn variant="primary" text="Button" @click="lkuCustomerShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append> -->
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Advertiser</label></b-input-group-prepend>
                    <b-form-input placeholder="Masukkan Advertiser" v-model="model.Advertiser" disabled></b-form-input>
                  </b-input-group>
                  <b-input-group >
                      <b-input-group-prepend><label>Brand</label></b-input-group-prepend>
                      <b-form-input placeholder="Masukkan Brand" v-model="model.brand" disabled></b-form-input>
                      <b-input-group-prepend><span class="ml-2 mr-1 pt-2">Category</span></b-input-group-prepend>
                    <b-form-input placeholder="Masukkan Category" v-model="model.kategori" disabled></b-form-input>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Nama Sales AE</label></b-input-group-prepend>
                    <b-form-input placeholder="Pilih Sales AE" v-model="model.SalesEx" readonly></b-form-input>
                    <b-input-group-append>
                      <b-btn variant="primary" text="Button" @click="lkuSalesaeShow=true" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Jenis Iklan</label></b-input-group-prepend>
                    <b-form-input placeholder="Pilih Jenis Iklan"  v-model="model.jiklan" :state="$v.model.jiklanid.$dirty ? !$v.model.jiklanid.$error : null" readonly></b-form-input>
                    <b-input-group-append>
                        <b-btn variant="primary" text="Button" @click="lkuJenisIklanShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                      <b-input-group-prepend><span class="ml-2 mr-1 pt-1">Warna</span></b-input-group-prepend>
                      <b-form-radio-group v-model="model.jwarna" id="jwarna" inline class="p-1" :state="$v.model.jwarna.$dirty ? !$v.model.jwarna.$error : null" @change="changeWarna">
                        <b-form-radio value="BW">BW</b-form-radio>
                        <b-form-radio value="Warna">FC</b-form-radio>
                      </b-form-radio-group>
                  </b-input-group>
                  <b-row>
                    <b-col lg="6">
                        <b-input-group >
                          <b-input-group-prepend><label>Harga Standard</label></b-input-group-prepend>
                          <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                          <my-number v-model="model.ratecard" class="text-right" readonly></my-number>
                        </b-input-group>                      
                    </b-col>
                    <b-col lg="6">
                      <b-input-group v-if="model.classad !== '2' && model.classad !== 2">
                        <b-input-group-prepend><span class="pt-2 mr-2">Ukuran(lebar x tinggi)</span></b-input-group-prepend>
                        <b-form-input placeholder="Lebar/Kolom" v-model="model.kol" type="number" v-b-tooltip.hover :title="model.kol" :state="$v.model.kol.$dirty ? !$v.model.kol.$error : null" class="small-input" min="1"></b-form-input>
                        <b-input-group-append><span class="input-group-text"> x </span></b-input-group-append>
                        <b-form-input placeholder="Tinggi/Milimeter" v-model="model.mili" type="number" v-b-tooltip.hover :title="model.mili" :state="$v.model.mili.$dirty ? !$v.model.mili.$error : null" class="small-input" min="1"></b-form-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-input-group v-if="model.classad === '0' || model.classad === 0" >
                    <b-input-group-prepend><label>Position/Rubrik</label></b-input-group-prepend>
                    <b-form-input v-model="model.posisirubrik" :state="$v.model.posisirubrik.$dirty ? !$v.model.posisirubrik.$error : null"></b-form-input>
                    <b-input-group-append>
                        <b-btn variant="primary" text="Button" @click="lkuRubrikShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                      </b-input-group-append>
                    <b-input-group-prepend><span class="ml-2 pt-1 mr-1">Materi Iklan</span></b-input-group-prepend>
                    <b-form-radio-group id="materijadi" label-for="materiIklan-input" inline class="p-1" v-model="model.materijadi" :state="$v.model.materijadi.$dirty ? !$v.model.materijadi.$error : null">
                        <b-form-radio value='Jadi'>Jadi</b-form-radio>
                        <b-form-radio value='Mentah'>Mentah</b-form-radio>
                    </b-form-radio-group>
                  </b-input-group>

                  <div v-if="model.classad === '2' || model.classad === 2">
                    <b-input-group :append="model.baris1.length>9?model.baris1.length.toString() : '0'+model.baris1.length.toString() || '00'">
                      <b-input-group-prepend><label>Materi Iklan Baris</label></b-input-group-prepend>
                      <b-form-input v-model="model.baris1" maxlength="40" placeholder="Baris 1"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris2.length>9?model.baris2.length.toString() : '0'+model.baris2.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris2" maxlength="40" placeholder="Baris 2"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris3.length>9?model.baris3.length.toString() : '0'+model.baris3.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris3" maxlength="40" placeholder="Baris 3"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris4.length>9?model.baris4.length.toString() : '0'+model.baris4.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris4" maxlength="40" placeholder="Baris 4"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris5.length>9?model.baris5.length.toString() : '0'+model.baris5.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris5" maxlength="40" placeholder="Baris 5"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris6.length>9?model.baris6.length.toString() : '0'+model.baris6.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris6" maxlength="40" placeholder="Baris 6"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris7.length>9?model.baris7.length.toString() : '0'+model.baris7.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris7" maxlength="40" placeholder="Baris 7"></b-form-input>
                    </b-input-group>
                    <b-input-group :append="model.baris8.length>9?model.baris8.length.toString() : '0'+model.baris8.length.toString() || '00'">
                      <b-input-group-prepend><label> </label></b-input-group-prepend>
                      <b-form-input v-model="model.baris8" maxlength="40" placeholder="Baris 8"></b-form-input>
                    </b-input-group>
                     <b-input-group :append="getTotalKarakter">
                      <b-input-group-prepend><label>Jumlah Baris Iklan</label></b-input-group-prepend>
                      <b-form-input v-model="model.jmlbaris" readonly></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col lg="6">                  
                  <b-input-group v-if="model.classad === '2' || model.classad === 2" >
                      <b-input-group-prepend><label>Kelompok Ik.Baris</label></b-input-group-prepend>
                      <b-form-select v-model="model.juduliklan" :plain="true" :options="kelompokIB" :state="$v.model.juduliklan.$dirty ? !$v.model.juduliklan.$error : null"></b-form-select>
                  </b-input-group>
                  <b-input-group v-else>
                    <b-input-group-prepend><label>Judul/Keterangan</label></b-input-group-prepend>
                    <b-form-input placeholder="Judul/Keterangan/Kelompok IB" v-model="model.juduliklan" maxlength="250" :state="$v.model.juduliklan.$dirty ? !$v.model.juduliklan.$error : null"></b-form-input>
                  </b-input-group>
                    <!-- <b-input-group >
                        <b-input-group-prepend><label>Frekuensi Muat</label></b-input-group-prepend>
                        <b-form-input  v-model="model.jmlmuat" type="number" :state="$v.model.jmlmuat.$dirty ? !$v.model.jmlmuat.$error : null" ></b-form-input>
                        <b-input-group-append><span class="input-group-text"> hari </span></b-input-group-append>
                          <b-form-radio-group
                            v-model="model.ispaket"
                            :options="options_ispaket"
                            name="radio-inline"
                            class="ml-2 pt-1"
                          ></b-form-radio-group>
                  </b-input-group> -->
                  <b-input-group >
                        <b-input-group-prepend><label>Frekuensi Muat</label></b-input-group-prepend>
                        <b-form-input  v-model="model.jmlmuat" type="number" :state="$v.model.jmlmuat.$dirty ? !$v.model.jmlmuat.$error : null" ></b-form-input>
                        <b-input-group-prepend><span class="pl-2 pt-2">Nilai ({{uanguser}})</span></b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="model.gross" :precision="2"  style="width:15% !important;"></my-number>
                        <b-input-group-prepend><span class="pl-2 pt-2">Harga Satuan</span></b-input-group-prepend>
                        <my-number v-model="model.price" class="text-right" readonly></my-number>
                  </b-input-group>

                  <b-row class="justify-content-center mb-0" >
                      <v-date-picker
                        v-model="tgl_akan_muat"
                        :columns="layout.columns"
                        :rows="layout.rows"
                        :is-expanded="layout.isExpanded"
                        @dayclick="selectDate"
                        mode="multiple"
                        is-inline class="ml-5"
                      />
                  </b-row>

                  <table v-if="tgl_akan_muat.length>0">
                    <tr>
                      <td style="width:150px;"><button class="btn btn-danger" @click="clearDate()" size="sm"><i class="fa fa-trash"></i> Clear {{tgl_akan_muat.length}} Date</button></td>
                      <td><span v-for="(tgl,idx) in tgl_akan_muat" :key="tgl" class="pt-2"><span v-if="(idx>0)">, &nbsp;</span>{{ tgl | moment("DDMMM") }}</span>
                      <button class="btn btn-secondary ml-1" @click="sortDate()" size="sm">sort</button>                      
                      </td>
                    </tr>
                  </table>
                </b-col>
              </b-row>
            <hr>
            <b-row>
               <b-col lg="6">
                  <b-input-group >
                        <b-input-group-prepend><label>Frekuensi Muat</label></b-input-group-prepend>
                        <b-form-input  v-model="model.jmlmuat" type="number" :state="$v.model.jmlmuat.$dirty ? !$v.model.jmlmuat.$error : null" ></b-form-input>
                        <b-input-group-prepend><span class="pl-2 pt-2">Nilai ({{uanguser}})</span></b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="model.gross" :precision="2"  style="width:15% !important;"></my-number>
                        <b-input-group-prepend><span class="pl-2 pt-2">Harga Satuan</span></b-input-group-prepend>
                        <my-number v-model="model.price" class="text-right" readonly></my-number>
                  </b-input-group>
                  <b-input-group >
                    <b-input-group-prepend><label>Bentuk Pembayaran</label></b-input-group-prepend>
                    <b-form-select v-model="model.jenisbayar" :options="paymentForms" :plain="true" class="mr-2" disabled></b-form-select>
                  </b-input-group>

               </b-col>
               <b-col lg="6">
                  <b-input-group >
                      <b-input-group-prepend><label>Bukti Iklan Koran</label></b-input-group-prepend>
                      <b-form-input v-model="model.buktiiklan" type="number" :state="!$v.model.buktiiklan.$error"></b-form-input>
                      <b-input-group-append><span class="input-group-text"> eksemplar </span></b-input-group-append>
                      <b-input-group-append><span class="p-2" > <i class="fa fa-arrow-right" ></i> </span></b-input-group-append>

                      <b-input-group-append><span class="p-2"> ke Biro/Agency </span></b-input-group-append>
                      <b-form-input v-model="model.buktiiklancust" type="number" :state="!$v.model.buktiiklancust.$error"></b-form-input>
                      <b-input-group-append><span class="p-2" > <i class="fa fa-plus-square" ></i> </span></b-input-group-append>
                      
                      <b-input-group-append><span class="pt-2"> ke Advertiser </span></b-input-group-append>
                      <b-form-input v-model="model.buktiiklanadv" type="number" :state="!$v.model.buktiiklanadv.$error"></b-form-input>
                  </b-input-group>
               </b-col>
            </b-row>

              <!-- <b-row class="expand-input">
                <b-col lg="6">
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Gross</label></b-input-group-prepend>
                        <b-form-input v-model="model.grossdesc" @keydown.enter.native="handleEnterAmt" v-b-tooltip.hover title="Ctrl+ENTER for Auto Build" placeholder="gross description" disabled></b-form-input>
                        <b-input-group-append>
                          <b-btn variant="secondary" text="Button" @click="calcGross" v-b-tooltip.hover title="Hitung Gross dari Formula disamping" disabled>
                              <i class="fa fa-calculator"></i>
                          </b-btn>
                        </b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.gross" :precision="2" disabled></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Discount</label></b-input-group-prepend>
                        <b-form-select v-model="model.calcDisc" :plain="true" :options="calcuationDisc"  style="width:25% !important;" disabled></b-form-select>
                        <my-number class="text-right ml-1" v-model="model.diskonpc" :readonly="(model.calcDisc===0)" :precision="2" v-b-tooltip.hover :title="model.diskonpc" disabled></my-number>
                        <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.diskon" :readonly="(model.calcDisc===1)" :precision="2"></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                    <b-input-group >
                      <b-input-group-prepend><label>Pendapatan Lain</label></b-input-group-prepend>
                      <b-form-input v-model="model.revlaindesc"  placeholder="contoh: pembuatan materi" disabled></b-form-input>
                    </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.revlain" :precision="2" disabled></my-number>
                      </b-input-group>                                            
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Netto</label></b-input-group-prepend>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.dpp" :precision="2" disabled></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>PPN</label></b-input-group-prepend>
                        <b-form-select v-model="model.calcVAT" :plain="true" :options="calcuationVAT" style="width:37% !important;" disabled></b-form-select>
                        <b-form-input :value="tarifPPN" readonly class="text-right ml-1"></b-form-input>
                        <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.ppn" :readonly="(model.calcVAT===1)" :precision="2"></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="7">
                      <b-input-group >
                        <b-input-group-prepend><label>Grand Total</label></b-input-group-prepend>
                      </b-input-group>
                    </b-col>
                    <b-col md="5">
                      <b-input-group >
                        <b-input-group-append><span class="input-group-text"> {{uanguser}} </span></b-input-group-append>
                        <my-number class="form-control text-right" v-model="model.total" :precision="2" readonly></my-number>
                      </b-input-group>                      
                    </b-col>
                  </b-row>
                </b-col>
                <b-col lg="6">
                    <b-row no-gutters>
                        <b-col lg="6">
                            <b-input-group >
                            <b-input-group-prepend><label>Bentuk Pembayaran</label></b-input-group-prepend>
                            <b-form-select v-model="model.jenisbayar" :options="paymentForms" :plain="true" class="mr-2"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><span class="input-group-text">Cara Bayar</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.iscash" >
                                    <b-form-radio value=0>Invoicing</b-form-radio>
                                    <b-form-radio value=1>Tunai (dimuka)</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-row no-gutters v-if="(model.iscash!=1)">
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Billing Invoice</label></b-input-group-prepend>
                                <b-form-select v-model="model.billing" :options="invoicingTerms" :plain="true" class="mr-2"></b-form-select>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6" >
                            <b-input-group >
                                <b-input-group-prepend><span class="input-group-text">Tujuan Invoice</span></b-input-group-prepend>
                                <b-form-radio-group inline class="p-1" v-model="model.billtoadv" >
                                    <b-form-radio value=0>Agency</b-form-radio>
                                    <b-form-radio value=1>Advertiser</b-form-radio>
                                </b-form-radio-group>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-input-group v-if="(model.billing=='PER TERMIN')">
                        <b-input-group-prepend><label>Termin Invoicing</label></b-input-group-prepend>
                        <b-form-input v-model="model.keteranganbayar" placeholder="Keterangan Termin Invoicing" class="mr-5"></b-form-input>
                    </b-input-group>

                  <b-input-group >
                      <b-input-group-prepend><label>Bukti Iklan Koran</label></b-input-group-prepend>
                      <b-form-input v-model="model.buktiiklan" type="number" :state="!$v.model.buktiiklan.$error"></b-form-input>
                      <b-input-group-append><span class="input-group-text"> eksemplar </span></b-input-group-append>
                      <b-input-group-append><span class="p-2" > <i class="fa fa-arrow-right" ></i> </span></b-input-group-append>

                      <b-input-group-append><span class="p-2"> ke Biro/Agency </span></b-input-group-append>
                      <b-form-input v-model="model.buktiiklancust" type="number" :state="!$v.model.buktiiklancust.$error"></b-form-input>
                      <b-input-group-append><span class="p-2" > <i class="fa fa-plus-square" ></i> </span></b-input-group-append>
                      
                      <b-input-group-append><span class="pt-2"> ke Advertiser </span></b-input-group-append>
                      <b-form-input v-model="model.buktiiklanadv" type="number" :state="!$v.model.buktiiklanadv.$error"></b-form-input>
                  </b-input-group>

                  <div class="bordered"></div>
                  <transition name="slide-fade">
                    <div v-if="((model.billtoadv==1) || (model.buktiiklanadv>0))">
                      <b-input-group>
                        <b-input-group-prepend><label>Nama Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advnama" placeholder="Nama Advertiser sesuai NPWP" style="width:40% !important;"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">NPWP</span></b-input-group-prepend>
                        <b-form-input v-model="model.advnpwp" placeholder="NPWP"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Alamat Advertiser</label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr1" placeholder="Alamat 1"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label> </label></b-input-group-prepend>
                        <b-form-input v-model="model.advaddr2" placeholder="Alamat 2"></b-form-input>
                      </b-input-group>
                      <b-input-group>
                        <b-input-group-prepend><label>Telepon</label></b-input-group-prepend>
                        <b-form-input v-model="model.advtelp" placeholder="No Telepon"></b-form-input>
                        <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Fax</span></b-input-group-prepend>
                        <b-form-input v-model="model.advcity" placeholder="No. Fax"></b-form-input>
                      </b-input-group>
                    </div>
                  </transition>

                  </b-col>
              </b-row> -->
            <hr>

            <b-row class="justify-content-center mb-2">
                <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                  <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <b-button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close Form</b-button>
            </b-row>
        </b-card>
        <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true" :lazy="true">
            <lku-customer @click="onSelectLkuCustomer"></lku-customer>
        </b-modal>   
        <b-modal v-model="lkuSalesaeShow" size="lg" :hide-footer="true" title="List of Sales AE" :centered="true" :lazy="true">
            <lku-salesae @click="onSelectLkuSalesae" crudfilter="iklan=1"></lku-salesae>
        </b-modal> 
         <b-modal v-model="lkuJenisIklanShow" size="lg" :hide-footer="true" title="Jenis Iklan" :centered="true" :lazy="true">
            <lku-jenisiklan @click="onSelectLkuJenisIklan" ></lku-jenisiklan>
        </b-modal>  
        <b-modal v-model="lkuSoShow" size="lg" :hide-footer="true" title="List of Sales Order (Customer P.O)"  :key="model.customer_id" :centered="true">
            <lku-salesorder @click="onSelectLkuSo"  iklancetak="1" statusopi="0" :byae="byae"></lku-salesorder>
            <!-- <lku-salesorder @click="onSelectLkuSo" :customer="model.custinfo" :customer_id="model.customer_id" iklancetak="1" statusopi="0" :byae="byae"></lku-salesorder> -->
        </b-modal>        
         <b-modal v-model="lkuRubrikShow" size="lg" :hide-footer="true" title="HALAMAN/RUBRIK" :centered="true" :lazy="true">
            <lku-koranrubrik @click="onSelectLkuRubrik" ></lku-koranrubrik>
        </b-modal>  

    </div>
</template>
<style scoped>
/* .my-datepicker >>> .my-datepicker_calendar {
  width: 100%;
  height: 30px;
} */
.vc-container {
  margin: 10px 10px 10px 10px!important;
}
</style>
<style lang="scss">
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 90px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
// import VCalendar from 'v-calendar';
import opi from "../../apis/koran_iklanorder";
import moment from 'moment';
import accounting from 'accounting-js'
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
import lkuCustomer from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuJenisiklan from "../lookup/lkuJenisIklanAll";
import lkuSalesorder from "../lookup/lkuSalesOrderLine";
import lkuKoranrubrik from "../lookup/lkuKoranrubrik";

toastr.init();


function compareNumbers(a, b) {
  return a - b;
}
export default {
  mixins: [validationMixin],
  validations: {
    model: {
        platform: { required }, 
        orderdate: { required }, 
        customer_id: { required }, 
        // brand: { required }, 
        // kategori: { required }, 
        // Advertiser: { required }, 
        juduliklan: { required },
        materijadi: { required },
        // posisirubrik: { required }, 
        posisirubrik: {required : (function() {
            if (this.model.classad!=0) {
                return true;
            } else if (!(this.model.posisirubrik)){
                return false;
            } else return true;
        })},
        jiklanid: { required },
        jwarna: { required },
        kol: {required : (function() {
            if (this.model.classad=='2') {
                return true;
            } else if (!(this.model.kol)){
                return false;
            } else return true;
        })},
        mili:  {required : (function() {
            if (this.model.classad=='2') {
                return true;
            } else if (!(this.model.mili)){
                return false;
            } else return true;
        })},
        buktiiklan: { required },
        buktiiklancust: {required : (function() {
            if (!(this.model.buktiiklanadv)) {
                return true;
            } else if (!(this.model.buktiiklancust)){
                return false;
            } else return true;
        })},
        buktiiklanadv: {required : (function() {
            if (!(this.model.buktiiklancust)) {
                return true;
            } else if ((this.model.buktiiklancust==this.model.buktiiklan)){
                this.model.buktiiklanadv=0;
                return true;
            } else if (!(this.model.buktiiklanadv)){
                return false;
            } else return true;
        })},
        // ispaket: { required },
        jmlmuat: { required, minValue:minValue(1) },
        // jenisbayar: { required }
    },
  }, 
  components:{myNumber, lkuCustomer, lkuSalesae, lkuJenisiklan, lkuSalesorder,lkuKoranrubrik},
  data() {
    return {
      inputBerlanjut:1,
      lkuCustomerShow: false,
      lkuSalesaeShow: false,
      lkuJenisIklanShow: false,
      lkuRubrikShow: false,
      lkuSoShow: false,
      lkuSoData:{},
      selectedIklan: {},
      saveEnabled:true,
      minDate: new Date(),
      uanguser: this.$store.state.user.matauang,
      options_ispaket: [
          { text: 'Satuan', value: '0' },
          { text: 'Paket/Kontrak', value: '1' }
      ],
      orderLines:[], tgl_akan_muat:[],
      calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
      calcuationDisc : [{ value: 1, text: 'Disc (Auto Calc)' }, { value: 0, text: 'Disc (Manual Calc)' }],
      kelompokIB:['LOWONGAN PEKERJAAN', 'MOBIL DIJUAL', 'RUMAH DIJUAL'],
      paymentForms:[{value:'STANDARD', text: 'Standard Cash/Bank'}],
      invoicingTerms:[
          {value:'DI AWAL', text: 'DI AWAL'},
          {value:'PER TERMIN', text: 'PER TERMIN'},
            {value:'PER TAYANG', text: 'PER TAYANG'},
            {value:'PER BULAN', text: 'PER BULAN'},
            {value:'DI AKHIR', text: 'DI AKHIR'}
      ],
      tarifPPN: this.$store.state.user.tarifppn || 10,
      model:{
        platform: 'cetak',orderid:'',
        orderno: '',calcVAT:1, calcDisc:1,
        orderdate: moment().format('YYYY-MM-DD'), 
        pemasang: '', SalesEx:'', 
        custinfo: '',
        customer_id: '', 
        customer_name: '', 
        Advertiser: '', 
        mediaorder: '', 
        juduliklan: '', 
        kol: 0, 
        mili: 0, 
        ispaket: 1,
        jmlmuat: 0,
        price:0, ratecard:0,
        kategori: '',
        brand: '',
        jiklanid: '',
        jiklan: '',
        classad:0,
        jwarna: 'BW',
        posisirubrik: '',
        materijadi: 'Jadi',
        matauang: this.$store.state.user.matauang,
        iscash: 0,
        oncashnote: '',
        jttempo: '',
        gross: 0,
        grossdesc: '',
        diskon: 0,
        diskonpc: 0,
        dpp: 0,
        ppn: 0,
        revlain: 0,
        revlaindesc: '',
        total: 0,
        totaliklan: 0,
        billb4comp: 0,
        proforma: 0,
        billing: 'DI AKHIR',
        billtoadv: 0,
        buktiiklanadv: 0,
        buktiiklan: 0,
        advnama: '',
        advnpwp: '',
        advaddr1: '',
        advaddr2: '',
        advcity: '',
        advtelp: '',
        accexec: '',
        completeda: null,
        isstoped: 0,
        invoiceno: '',
        invoicedate: null,
        isinvoiced: 0,
        jmlbaris: 0,
        baris1: '',
        baris2: '',
        baris3: '',
        baris4: '',
        baris5: '',
        baris6: '',
        baris7: '',
        baris8: '',
        jenisbayar: 'uang',
        keteranganbayar: '',
        posted: 0,
        createby: this.$store.state.user.username,
        compcode: this.$store.state.user.compcode,
      },
      byae:0
    };
  },
  computed: {
    getTotalKarakter() {
      let jml = 0;
      let jmlbaris = 0;
      for (let i=1;i<=8;i+=1) {
        const val = this.model['baris'+i];
        if (val.length > 0) {
          jmlbaris += 1;
          jml += val.length;
        }
      }
      this.model.jmlbaris = jmlbaris;
      return jml > 9 ? jml.toString() : '0' + jml.toString() || '00';
    },
    layout() {
      return this.$screens(
        {
          // Default layout for mobile
          default: {
            columns: 1,
            rows: 1,
            isExpanded: true,
          },
          // Override for large screens
          md: {
            columns: 2,
            rows: 1,
            isExpanded: false,
          },
          lg: {
            columns: 2,
            rows: 1,
            isExpanded: false,
          },
        },
      );
    },
    tblFields(){
      const fields=[
          {
            key: "orderno",
            label: "Order No",
            sortable: true
          },
          {
            key: "orderdate",
            label: "Date",
            sortable: true
          },
          "pemasang",
          "Advertiser",
          {
            key: "juduliklan",
            label: "Judul Iklan",
            // thStyle: "width:60px",
            // thClass: "text-center",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          } 
         ];
      return fields;
    },
    invalidFormdata() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    gross(){
        return this.model.gross;
    },    
    discpc(){
        return this.model.diskonpc;
    },    
    discvalue(){
        return this.model.diskon;
    },    
    revlain(){
      return this.model.revlain;
    },
    vattotal(){
        return this.model.ppn;
    },    
  },
  watch: {
    gross: function(newval) {
        if (this.model.calcDisc == 1){
          this.model.diskon = parseFloat(newval) * parseFloat(this.model.diskonpc) / 100;;        
        }
        this.calcTaxes();
    },  
    discpc: function(newval) {
        if (this.model.calcDisc == 1){
          this.model.diskon = parseFloat((this.model.gross || 0)) * parseFloat(this.model.diskonpc) / 100;;        
          this.calcTaxes();
        }
    },    
    discvalue: function(newval) {
        if (this.model.calcDisc == 1){
          // this.model.diskonpc = parseFloat(accounting.formatNumber(this.model.diskon/this.model.gross)) * 100;
          this.model.diskonpc = (parseFloat(this.model.diskon)/parseFloat(this.model.gross)) * 100;
        } else if (!(this.model.discpc)){
          this.model.diskonpc = (parseFloat(this.model.diskon)/parseFloat(this.model.gross)) * 100;
        }
        this.calcTaxes();
    },  
    revlain: function(newval) {
        this.calcTaxes();
    },  
    vattotal: function(newval) {
        this.model.total = parseFloat(this.model.dpp) + parseFloat(this.model.ppn);
    },    
    // 'model.jmlbaris': function () {
    //   this.getGrossDescription();
    // },
    // 'model.kol': function () {
    //   this.getGrossDescription();
    // },
    //  'model.mili': function () {
    //   this.getGrossDescription();
    // }

  },
  created: async function(){
    const routeAsal = localStorage.getItem('opiCbyae');
   if (routeAsal ==  "iklankoran.iklankoranbyae") {
      console.log('masuk byae ');
      this.byae=1;
   }
    // console.log(this.$route.params);
    // if (this.$route.params.byae==1)  {
    //   console.log('masuk byae');
    //   this.byae=1;
    // }

        if (this.$route.params.orderid)  {
          toastr.info('Loading OPI Detail, please wait')
          this.inputBerlanjut=0;
          try {
            const [a,f,data] = await Promise.all([opi.kelompokib(),opi.paymentForms(),opi.detail(this.$route.params)]) ;
            this.kelompokIB=a;
            this.paymentForms=f;
            // const data = await opi.detail(this.$route.params);  
            const row = data[0];
            // console.log('row: ', row);
            this.saveEnabled=(row.posted === 0);
            row.orderdate = row.orderdate ? moment(row.orderdate).format('YYYY-MM-DD') : '';

            for (var key in row) {
                this.model[key] = row[key];
            }
        
            // console.log('model: ', this.model);
            // this.model.SalesEx = this.model.salesae_name.trim();
            // this.model.price = this.model.price;
            // this.model.jiklaninfo = this.model.jiklanid + ' | ' + this.model.jdisplay.trim();
            // GET SELECTED IKLAN
            this.selectedIklan.classad = this.model.classad;
            this.selectedIklan.jiklanid = this.model.jiklanid;
            this.selectedIklan.hargabw = this.model.hargabw;
            this.selectedIklan.hargafc = this.model.hargafc;
            this.selectedIklan.uraian = this.model.uraian_jiklan;

            this.orderLines =data[1];
            this.selectedIklan = data[2];

            this.tgl_akan_muat = [];
            this.orderLines.forEach((jd,idx)=>{
              this.tgl_akan_muat.push(new Date(moment(jd.jadwalmuat).format('YYYY-MM-DD')));
              // if (idx==0){
              //     this.minDate=this.tgl_akan_muat[idx];
              // }
              // this.tgl_akan_muat.push(jd.jadwalmuat);
              this.orderLines[idx].jadwalmuat = moment(jd.jadwalmuat).format('YYYY-MM-DD');
            });
            // this.minDate = lines && lines.length>0 ? (new Date(lines[0].jadwalmuat) < new Date() ? new Date(lines[0].jadwalmuat) : new Date()) : new Date();

            // this.getGrossDescription();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
        } else {
            this.model.orderdate  = moment().format('YYYY-MM-DD');
            const [a,f] = await Promise.all([opi.kelompokib(),opi.paymentForms()]) ;
            this.kelompokIB=a;
            this.paymentForms=f;
        }
        console.log('save enabled: ', this.saveEnabled);
        this.$watch('model.jmlmuat', function(newVal) {
            if (newVal==this.model.jmlmuat) {
                setTimeout(() => {
                  this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlmuat);
                }, 100);
            }
        });            
        this.$watch('model.gross', function(newVal) {
            if (newVal==this.model.gross) {
                setTimeout(() => {
                    this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlmuat);
                }, 100);
            }
        });            

  },
  methods: {
    calcGross: function() {
        try {   
            if (this.model.grossdesc) {
                let geval=eval;
                let NilaiFix = geval(`${this.model.grossdesc};`);
                this.model.gross =  parseFloat(NilaiFix) || 0;
            } else {
                toastr.info('isi Gross description dg Formula, contoh: (5 * 100 * 100) ','INFO',10000);
            }

        } catch (error) {
            console.log('error : ', error);
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },
    calcTaxes : function() {
        this.model.totaliklan = parseFloat(this.model.gross) - parseFloat(this.model.diskon);
        this.model.dpp = parseFloat(this.model.totaliklan) + parseFloat(this.model.revlain);
        if (this.model.calcVAT == 1){
            this.model.ppn = (this.tarifPPN/100) * this.model.dpp;
        }
      this.model.total = this.model.dpp + parseFloat(this.model.ppn);

        this.$forceUpdate();
    },    
    changeWarna(val) {
      if(this.selectedIklan) {
        if(val==="BW"){
            // this.model.price = this.selectedIklan.hargabw;
            this.model.ratecard = this.selectedIklan.hargabw;
        } else {
            // this.model.price = this.selectedIklan.hargafc;
            this.model.ratecard = this.selectedIklan.hargafc;
        }
      } else {
          // this.model.price = 0;
          this.model.ratecard = 0;
      }
      if (!(this.model.price)) {
        this.model.price = this.model.ratecard;
      }
      
      // this.getGrossDescription();
    },
    getGrossDescription () {
      if(this.model.classad === '2' || this.model.classad === 2 ) {
        // GET GROSS
        // this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.jmlbaris} * ${accounting.formatNumber(this.model.price, 0)} )`;
        this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.jmlbaris} * ${this.model.price} )`;
        this.model.ukuraniklan = '';
        const gross = parseFloat(this.model.jmlmuat) * parseFloat(this.model.jmlbaris) * parseFloat(this.model.price);
        this.model.gross = gross;
      } else {
        // GET GROSS
        // this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.kol} * ${this.model.mili} * ${accounting.formatNumber(this.model.price, 0)} )`;
        this.model.ukuraniklan = `${this.model.kol} * ${this.model.mili}`;
        if (this.model.platform=='cetak') {
          this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.kol} * ${this.model.mili} * ${this.model.price} )`;
          const gross = parseFloat(this.model.jmlmuat) * parseFloat(this.model.kol) * parseFloat(this.model.mili) * parseFloat(this.model.price);
          this.model.gross = gross;
        } else {
          this.model.grossdesc = `( ${this.model.jmlmuat} * ${this.model.price} )`;
          const gross = parseFloat(this.model.jmlmuat) * parseFloat(this.model.kol) * parseFloat(this.model.mili) * parseFloat(this.model.price);
          this.model.gross = gross;

        }
      }
  
      // GET DISCOUNT
      let disc = parseFloat(accounting.formatNumber(this.model.diskon/this.model.gross)) * 100;
      this.model.diskonpc = isNaN(disc) ? 0 : disc;
      // GET NETTO
      this.model.dpp = this.model.gross - parseFloat(this.model.diskon);
      // GET TAX
            this.model.ppn = (this.tarifPPN/100) * this.model.dpp;
      // GET TOTAL
      this.model.totaliklan = this.model.dpp + this.model.ppn;
      // GET GRAND TOTAL
      this.model.total = this.model.totaliklan + parseFloat(this.model.revlain);
      // GET SILENT DISC %
      let silent_pc = parseFloat(accounting.formatNumber(this.model.silentdisc/this.model.total)) * 100;
      this.model.silent_pc = isNaN(silent_pc) ? 0 : silent_pc;
      // GET TOTAL PAYMENT
      this.total_bayar = this.model.total - this.model.silentdisc;
    },
    handleEnterAmt: function (e) {
      // handle CTRL+ENTER , mengisi otomatis Gross description
      if (e.ctrlKey) {
          this.getGrossDescription();
      }  
    },

    onSelectLkuCustomer: async function (_selected) {
      this.model.custinfo = _selected.CustName.trim()+ ' | '+_selected.CustCode.trim();
      this.model.customer_id = _selected.customer_id;
      this.model.customer_name = _selected.CustName.trim();
      this.lkuCustomerShow=false;
    },    
    onSelectLkuSalesae: async function (_selected) {
      // this.model.SalesEx = _selected.salesae_id.trim() + ' | ' + _selected.salesae_name.trim();
      this.model.SalesEx = _selected.salesae_name.trim();
      // this.model.accexec = _selected.crewnik;
      this.model.accexec = _selected.salesae_id;
      this.model.salesae_id = _selected.salesae_id;
      // this.model.customer_name = _selected.salesae_name.trim();
      this.lkuSalesaeShow=false;
    },    
    onSelectLkuSo(_selected) {
        this.lkuSoShow=false;
        this.model.calcDisc=0;
        this.model.calcVAT=0;
        this.model.salesHdrKey=_selected.salesHdrKey;
        this.model.salesDtlKey=_selected.salesDtlKey;
        this.model.mediaorder=_selected.nomor;
        if (!(this.model.juduliklan)) {
            this.model.juduliklan=`${_selected.itemname} | ${_selected.description} `;
        }
        this.model.matauang=_selected.matauang;
        this.model.jenisbayar=_selected.jenisbayar;
        this.model.keteranganbayar=_selected.keteranganbayar;
        this.model.custinfo = _selected.CustName.trim()+ ' | '+ _selected.CustCode.trim();
        this.model.customer_id = _selected.customer_id;
        this.model.customer_name = _selected.CustName.trim();
        this.model.Advertiser=_selected.Advertiser;
        this.model.brand=_selected.brand;
        this.model.kategori=_selected.kategori;
        this.model.SalesEx=_selected.SalesEx;
        this.model.accexec=_selected.SalesExCode;
        const arrJadwal=JSON.parse(_selected.jadwal); 
        // this.model.jmlmuat = arrJadwal.length ;    
        this.model.jmlmuat = _selected.qtyOrder;      
        this.tgl_akan_muat = [];
        arrJadwal.forEach((jd,idx)=>{
          this.tgl_akan_muat.push(new Date(jd));
          this.orderLines.push({jadwalmuat: moment(jd).format('YYYY-MM-DD')});
        });

        this.model.iscash=_selected.iscash;
        this.model.proforma=_selected.proforma;
        this.model.billing=_selected.billing;
        this.model.billtoadv=_selected.billtoadv;
        this.model.advnama=_selected.advnama;
        this.model.advnpwp=_selected.advnpwp;
        this.model.advaddr1=_selected.advaddr1;
        this.model.advaddr2=_selected.advaddr2;
        this.model.advcity=_selected.advcity;
        this.model.advtelp=_selected.advtelp;
        this.model.grossdesc=`${_selected.qtyOrder} * ${_selected.priceOrder}`;
        // this.model.gross = _selected.grossOrder;
        // this.model.diskon=_selected.discOrder;
        // this.model.diskonpc = _selected.priceDiscPc;
        // this.model.dpp = _selected.nettOrder;
        // this.model.ppn = _selected.nilaippn;
        //  this.model.totaliklan = _selected.nilaidue;
        this.model.gross = _selected.nettSales;
        this.model.totaliklan = _selected.nettSales;
        this.model.total = _selected.nettSales;
        this.model.price = parseFloat(this.model.gross) / parseInt(this.model.jmlmuat);

        // this.updateDimDtl2Hdr(_selected);
    },    
    onSelectLkuRubrik:function (_selected) {
      this.lkuRubrikShow=false;
      this.model.posisirubrik = _selected.rubrikname;
    },    
    onSelectLkuJenisIklan: function (_selected) {
      this.model.jiklanid = _selected.jiklanid;
      this.model.jiklan = _selected.jenisiklan;
      this.model.classad = _selected.classad;
      this.model.jwarna = 'BW';
      // this.model.price = _selected.hargabw;
      this.model.ratecard= _selected.hargabw;
       
      this.selectedIklan =  _selected;
      // this.getGrossDescription();
      this.lkuJenisIklanShow=false;
    },    
    // groupiklanChange(val) {
    //   this.model.classad = val;
    //   // RESET JENIS IKLAN
    //   this.model.jiklaninfo = null;
    //   this.model.jiklanid = null;
    //   this.model.jiklan = null;
    //   // row = {};
    //   this.selectedIklan = {};
    //   this.model.price = 0;
    //   this.model.jwarna = 'BW';
    //   this.model.kol = 0;
    //   this.model.mili = 0;
    //   document.getElementById("jiklaninfo").value = "";
    //   this.getGrossDescription();
    // },
    clearDate() {
       this.tgl_akan_muat = [];
       this.orderLines = [];
      //  this.getGrossDescription();
    },
    selectDate(val) {
        const date = moment(val.date).format('YYYY-MM-DD');
        const index = this.orderLines.findIndex(line => line.jadwalmuat === date);      
        // const index = this.orderLines.indexOf(date);
        if (index > -1) {
          if (this.orderLines[index].istayang) {
                toastr.error(`Iklan sudah tayang pada tanggal ${date}, tidak bisa diubah/dihapus `,'ERROR MESSAGE',5000);
                this.tgl_akan_muat = [];
                this.orderLines.forEach((jd)=>{
                  this.tgl_akan_muat.push(new Date(jd.jadwalmuat));
                });
                this.$forceUpdate();
          } else {
            this.tgl_akan_muat.splice(index, 1);
            this.orderLines.splice(index, 1);
          }
        } else {
          this.tgl_akan_muat.push(new Date(date));
          this.orderLines.push({jadwalmuat: date});
        }
        // HITUNG QTY MUAT & GROSS DESCRIPTION
        // this.model.jadwalmuat = this.tgl_akan_muat.length;
        // this.model.jmlmuat = this.tgl_akan_muat.length;
        // this.getGrossDescription();
    },
    sortDate() {
       this.tgl_akan_muat.sort((a, b) => {   
         if ( a < b ){
            return -1;
          }
          if ( a > b ){
            return 1;
          }
          return 0;
      });
       this.orderLines.sort((a, b) => {   
         if ( a.jadwalmuat < b.jadwalmuat ){
            return -1;
          }
          if ( a.jadwalmuat > b.jadwalmuat ){
            return 1;
          }
          return 0;
      });
    },
    save: async function (callback) {
      // const user = this.$store.state.user.username;
      // const compcode = this.$store.state.user.compcode;
      if (!(this.saveEnabled)) return;
          this.saveEnabled=false;      
      if (this.invalidFormdata) {
        const invalidobj={};
        for (var key in this.$v.model) {
        if (this.$v.model[key].$anyError) {
            if (this.$v.model[key].$anyError==true) invalidobj[key] = this.$v.model[key];
        }
        }        
        console.log('validation model: ', this.model);
        console.log('validation field: ', invalidobj);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
          this.saveEnabled=true;
      } else if (this.tgl_akan_muat.length==0) {
          toastr.error(`Jadwal Muat harus diisi!`, "ERROR MESSAGE",5000);
          this.saveEnabled=true;
      } else if ((this.tgl_akan_muat.length- parseInt(this.model.jmlmuat))>0) {
          toastr.error(`Jadwal Muat melebihi Frekuensi muat`, "ERROR MESSAGE",5000);
          this.saveEnabled=true;
      } else {
        try {
          if ((parseInt(this.model.jmlmuat) - this.tgl_akan_muat.length)>0) {
              toastr.warn(`Frekuensi Muat tidak sesuai dg Tanggal Jadwal yg diplih ${this.model.jmlmuat} <> ${this.tgl_akan_muat.length}`,'WARNING MESSAGE',10000);
          }

          const data={};
          for (var key in this.model) {
              data[key] = this.model[key];
          }
          data.jmljadwal=this.tgl_akan_muat.length;
          data.orderdate = this.model.orderdate ? moment(this.model.orderdate).format('YYYY-MM-DD') : '';
          data.orderLines=this.orderLines;
          // await opi.save(data);
          // this.close();
                const hasil= await opi.save(data);
                toastr.success(`Complete successfully, Order Number ${hasil.orderno}`, "Save OPI",10000);

                if (this.inputBerlanjut==0){
                    this.close();
                } else {
                    this.saveEnabled=true;      
                    this.model.jmlspot = 0;
                    this.model.jmlmuat = 0;
                    this.model.gross = 0;
                    this.model.diskon = 0;
                    this.model.diskonpc = 0;
                    this.model.dpp = 0;
                    this.model.ppn = 0;
                    this.model.revlain = 0;
                    this.model.total = 0;
                    this.model.totaliklan = 0;
                    this.model.billtoadv = 0;
                    const keys = ['orderdate','platform','matauang', 'createby','jttempo','jmlspot', 'jmlmuat','ispaket','iscash','jttempo','billb4comp','proforma','billtoadv' ];                                        
                    for (var key in this.model) {
                        if (keys.indexOf(key) == -1) {
                            this.model[key] = '';
                        }
                    }
                    this.orderLines=[];
                    this.$v.model.$reset();                        
                }
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
            this.saveEnabled=true;            
        }
      }
    },    

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      // if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'iklankoran.iklankoranfrm')) {
      //   router.push({name:this.$store.state.prevRoute.name});
      // } else {
      //     // router.push("order-pasang-iklan");
      //      router.push({name :'iklankoran.iklankoran'});
      // }
           if (this.byae==1) {
             router.push({path: "order-iklan-koran-byae/1"});
           } else {
            router.push({name :'iklankoran.iklankoran'});
           }           

    }
  },
};
</script>
